import React from 'react';
import './Footer.css';
import sponsored1 from '../../assets/images/sponsored1.svg';
import sponsored2 from '../../assets/images/sponsored2.svg';
import sponsored3 from '../../assets/images/sponsored3.svg';
import sponsored4 from '../../assets/images/sponsored4.svg';
import sponsored5 from '../../assets/images/sponsored5.svg';
import sponsored6 from '../../assets/images/sponsored6.svg';
import sponsored7 from '../../assets/images/sponsored7.svg';
import sponsored8 from '../../assets/images/sponsored8.svg';
import sponsored9 from '../../assets/images/sponsore9.svg';
import Footerlogo from '../../assets/images/Footerlogo.svg';
import Facebook from '../../assets/images/Facebook.svg';
import Instagram from '../../assets/images/Instagram.svg';
import CallButton from '../Header/callbutton.js';
import AddressComponent from './AddressComponent.js';
import Phone from '../../assets/images/phone.svg'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="spons-logo">
          <div className="footer-sponsored">
            <img src={sponsored1} alt="Sponsored 1" />
            <img src={sponsored2} alt="Sponsored 2" />
            <img src={sponsored3} alt="Sponsored 3" />
            <img src={sponsored4} alt="Sponsored 4" />
            <img src={sponsored5} alt="Sponsored 5" />
            <img src={sponsored6} alt="Sponsored 6" />
            <img src={sponsored7} alt="Sponsored 7" />
            <img src={sponsored8} alt="Sponsored 8" />
            <img src={sponsored9} alt="Sponsored 9" />
          </div>
          <div className="social-media">
            <div className="facebook instface">
              <img src={Facebook} alt="Facebook" />
              <a href="https://www.facebook.com/ceenologica" target="_blank" rel="noopener noreferrer">Facebook</a>
            </div>
            <div className="instagram instface">
              <img src={Instagram} alt="Instagram" />
              <a href="https://www.instagram.com/ce.enologica?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">Instagram</a>
            </div>
            <AddressComponent className="address" />
            <CallButton img = {Phone} number="+995591090997" />
          </div>
        </div>
        <div className="Footerlogo">
          <p>&copy; {new Date().getFullYear()} Your Company. All rights reserved.</p>
          <img src={Footerlogo} alt="Footer Logo" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
